import { render, staticRenderFns } from "./CreateScheduledMessage.vue?vue&type=template&id=40d79308&scoped=true"
import script from "./CreateScheduledMessage.vue?vue&type=script&lang=js"
export * from "./CreateScheduledMessage.vue?vue&type=script&lang=js"
import style0 from "./CreateScheduledMessage.vue?vue&type=style&index=0&id=40d79308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d79308",
  null
  
)

export default component.exports